import React from 'react'
import {
  Box,
  Typography,
  Grid,
  Button,
} from '@mui/material'
import Header from '../components/header'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'

import background from '../_contentnew/pulsebanner2.webp'
import founderImage from '../_contentnew/about.webp'
import { useNavigate } from 'react-router-dom'

const About = () => {
  const navigate = useNavigate()
    
  const navigateLink = (link) => {
    navigate(link)
    window.scrollTo(0, 0)
  }

  return (
    <>
      <Header
        background={background}
        text="Our Story"
      />

      <Box
        sx={{
          backgroundColor: '#0A9B48',
          p: 3,
        }}
      >
        <Typography
          sx={{
            color: '#fff',
            textAlign: 'center',
            fontSize: {
              xs: '1rem',
              md: '1.4rem',
            },
            fontWeight: 600,
          }}
        >
          Founded in 2025 with a single truck, Pulse Pallets is built on hard
          work, sustainability and personal service.
        </Typography>
      </Box>

      <Box
        sx={{
          width: '90%',
          maxWidth: '1200px',
          mx: 'auto',
          py: 8,
        }}
      >
        {/* INTRO */}

        <Typography
          variant="h4"
          sx={{
            color: '#fff',
            fontWeight: 700,
            textAlign: 'center',
            mb: 3,
          }}
        >
          Built From The Ground Up
        </Typography>

        <Typography
          sx={{
            color: '#d7e3dd',
            textAlign: 'center',
            maxWidth: '900px',
            mx: 'auto',
            lineHeight: 1.8,
            mb: 8,
          }}
        >
          Hi, I'm Freddy, founder of Pulse Pallets.
          <br />
          <br />
          I launched the business in 2025 with a single 3.5 tonne truck, a
          2:1 BA Honours degree in Sports Business & Sports Law and a
          determination to build something better.
          <br />
          <br />
          What started as a one-man mobile operation near Basingstoke has
          grown into a business supplying quality wooden pallets across
          Hampshire and beyond. From day one, Pulse Pallets has been built on
          hard work, honesty and a commitment to doing things properly.
        </Typography>

        {/* FOUNDER STORY */}

        <Grid
          container
          spacing={6}
          alignItems="center"
          textAlign="center"
          sx={{ mb: 8 }}
        >
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={founderImage}
              alt="Freddy Byrne-Stevens"
              sx={{
                width: '100%',
                borderRadius: '12px',
                objectFit: 'cover',
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              sx={{
                color: '#fff',
                fontWeight: 700,
                mb: 3,
              }}
            >
              Why I Started Pulse Pallets
            </Typography>

            <Typography
              sx={{
                color: '#d7e3dd',
                lineHeight: 1.8,
                mb: 3,
              }}
            >
              While university gave me strong foundations in business,
              negotiation and operations, I always wanted to build something
              tangible. I wanted to create a business that delivered genuine
              value to customers while giving me the opportunity to build
              something of my own.
            </Typography>

            <Typography
              sx={{
                color: '#d7e3dd',
                lineHeight: 1.8,
                mb: 3,
              }}
            >
              As I learned more about the pallet industry, I noticed how many
              good pallets were being discarded despite still having plenty of
              life left in them. That didn't sit right with me.
            </Typography>

            <Typography
              sx={{
                color: '#d7e3dd',
                lineHeight: 1.8,
                mb: 3,
              }}
            >
              I believed there was a better way. By repairing, reusing and
              recycling pallets wherever possible, businesses could reduce
              waste, lower costs and keep quality products in circulation for
              longer.
            </Typography>

            <Typography
              sx={{
                color: '#d7e3dd',
                lineHeight: 1.8,
              }}
            >
              Starting Pulse Pallets at a young age has been the greatest
              education of my life. Every collection, delivery, customer and
              challenge has reinforced the importance of hard work,
              reliability and treating people properly.
            </Typography>
          </Grid>
        </Grid>

        {/* WHY PULSE PALLETS EXISTS}

        <Box
          sx={{
            backgroundColor: '#222023',
            border: '1px solid rgba(87,200,77,0.15)',
            p: { xs: 4, md: 6 },
            mb: 8,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: '#fff',
              fontWeight: 700,
              mb: 3,
            }}
          >
            More Than Just Pallets
          </Typography>

          <Typography
            sx={{
              color: '#d7e3dd',
              lineHeight: 1.9,
              maxWidth: '900px',
              mx: 'auto',
            }}
          >
            I created Pulse Pallets because I saw too many good pallets going
            to waste.
            <br />
            <br />
            In an industry that keeps the UK's supply chain moving, I believe
            we have a responsibility to do things differently. By repairing,
            reusing and recycling pallets wherever possible, I can help reduce
            landfill waste, lower costs for businesses and create genuine
            value.
            <br />
            <br />
            Sustainability isn't a marketing slogan for me. It's built into
            the way I operate every day. Every pallet that can be repaired and
            reused instead of discarded is a small step towards a more
            sustainable future.
          </Typography>
        </Box>

        {*//* HOW WE WORK */}

        <Typography
          variant="h4"
          sx={{
            color: '#fff',
            fontWeight: 700,
            textAlign: 'center',
            mb: 3,
          }}
        >
          How We Work
        </Typography>

        <Typography
          sx={{
            color: '#d7e3dd',
            textAlign: 'center',
            maxWidth: '900px',
            mx: 'auto',
            lineHeight: 1.8,
            mb: 6,
          }}
        >
          Pulse Pallets is a fully mobile service based near Basingstoke.
          I personally buy, repair, sell and deliver wooden pallets directly
          from my truck. Operating within a 50-mile radius allows me to
          provide fast response times, competitive pricing and the hands-on
          quality control that larger suppliers often can't match.
        </Typography>

        <Grid
          container
          spacing={3}
          sx={{ mb: 3 }}
        >
          {[
              {
                title: 'Buy',
                icon: <ShoppingCartOutlinedIcon sx={{ fontSize: 60, color: '#57C84D' }} />,
                text: 'Purchasing surplus and unwanted pallets from local businesses.',
              },
              {
                title: 'Repair',
                icon: <HandymanOutlinedIcon sx={{ fontSize: 60, color: '#57C84D' }} />,
                text: 'Restoring pallets wherever possible to maximise their lifespan.',
              },
              {
                title: 'Supply',
                icon: <Inventory2OutlinedIcon sx={{ fontSize: 60, color: '#57C84D' }} />,
                text: 'Providing quality pallets for warehousing, manufacturing and logistics.',
              },
              {
                title: 'Deliver',
                icon: <LocalShippingOutlinedIcon sx={{ fontSize: 60, color: '#57C84D' }} />,
                text: 'Reliable mobile delivery throughout Hampshire and surrounding areas.',
              },
          ].map((item) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={item.title}
            >
             <Box
              sx={{
                backgroundColor: '#222023',
                border: '1px solid rgba(87,200,77,0.15)',
                p: 4,
                height: '100%',
                textAlign: 'center',
                transition: 'all 0.3s ease',

                '&:hover': {
                  borderColor: '#57C84D',
                  transform: 'translateY(-4px)',
                },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mb: 3,
                }}
              >
                {item.icon}
              </Box>

              <Typography
                sx={{
                  color: '#fff',
                  fontWeight: 700,
                  mb: 2,
                  fontSize: '1.2rem',
                }}
              >
                {item.title}
              </Typography>

              <Typography
                sx={{
                  color: '#d7e3dd',
                  lineHeight: 1.8,
                }}
              >
                {item.text}
              </Typography>
            </Box>
            </Grid>
          ))}
        </Grid>

        <Box maxWidth={900} sx={{ mx: 'auto' }}>
          <Typography
            sx={{
              color: '#d7e3dd',
              textAlign: 'center',
              lineHeight: 1.8,
              mb: 8,
            }}
          >
            We supply standard UK pallets, Euro pallets and custom-sized pallets
            for warehousing, manufacturing, construction and logistics
            businesses throughout Hampshire and the surrounding areas.
          </Typography>
        </Box>

        {/* MISSION */}

        <Box
          sx={{
            backgroundColor: '#222023',
            border: '1px solid rgba(87,200,77,0.15)',
            p: { xs: 2, md: 6 },
            mx: 'auto',
            mb: 8,
            textAlign: 'center',
            maxWidth: { xs: '90%', sm: '80%'}
          }}
        >
        <Typography
          variant="h4"
          sx={{
            color: '#fff',
            fontWeight: 700,
            textAlign: 'center',
            mb: 2,
          }}
        >
          Our Mission
        </Typography>

        <Box
          sx={{
            textAlign: 'center'
          }}
        >
          <Typography
            sx={{
              color: '#d7e3dd',
              lineHeight: 2,
              maxWidth: '900px',
              mx: 'auto',
            }}
          >
            Pulse Pallets is about more than buying and selling pallets.
            <br />
            <br />
            My long-term goals are simple:
            <br />
            <br />
            • Become one of the most trusted pallet suppliers in the UK.
            <br />
            • Create stable and rewarding employment opportunities for local people.
            <br />
            • Build a secure future for my family.
            <br />
            • Give back to the community through opportunity and support.
            <br />
            • Reduce unnecessary waste by keeping quality pallets in circulation.
            <br />
            <br />
            Every pallet I save, repair and reuse contributes towards those goals.
          </Typography>
        </Box>
        </Box>

        {/* AREAS */}

        <Typography
          variant="h4"
          sx={{
            color: '#fff',
            fontWeight: 700,
            textAlign: 'center',
            mb: 4,
          }}
        >
          Areas We Cover
        </Typography>

        <Typography
          sx={{
            color: '#d7e3dd',
            textAlign: 'center',
            lineHeight: 2,
            maxWidth: '800px',
            mx: 'auto',
            mb: 8,
          }}
        >
          Based near Basingstoke, Pulse Pallets operates within a 50-mile
          radius, regularly supplying businesses in Reading, Winchester,
          Newbury, Southampton, Guildford and surrounding areas.
        </Typography>

        {/* CTA */}

        <Box
          sx={{
            backgroundColor: '#222023',
            border: '1px solid rgba(87,200,77,0.15)',
            p: { xs: 4, md: 6 },
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: '#fff',
              fontWeight: 700,
              mb: 3,
            }}
          >
            Ready To Work Together?
          </Typography>

          <Typography
            sx={{
              color: '#d7e3dd',
              lineHeight: 1.8,
              maxWidth: '700px',
              mx: 'auto',
              mb: 4,
            }}
          >
            Whether you have pallets to sell, need a reliable ongoing supply
            or want to discuss your specific requirements, I'd love to hear
            from you. I'm always happy to visit your site, arrange collection
            or deliver directly.
            <br />
            <br />
            Lets keep goods moving sustainabily, one pallet at a time.
          </Typography>

          <Button
            size="large"
            onClick={() => navigateLink('/contact')}
            sx={{
              backgroundColor: '#0A9B48',
              color: '#fff',
              minWidth: '220px',
              py: 2,
              px: 4,
              fontSize: '1rem',
              fontWeight: 700,
              letterSpacing: '1px',
              borderRadius: 0,

              '&:hover': {
                transform: 'translateY(-5px)',
                borderColor: 'white',
                border: '1px solid',
                boxShadow: '0 10px 30px rgba(87,200,77,0.15)',
                backgroundColor: '#57C84D'
              }
            }}
          >
            GET IN TOUCH →
          </Button>
        </Box>
      </Box>
    </>
  )
}

export default About